import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isSingleLevelPlacement',
  standalone: true,
})
export class IsSingleLevelPlacementPipe implements PipeTransform {
  transform(placement: string): boolean {
    return placement?.length > 0 && !placement?.includes('/');
  }
}
